import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SpecialBatchRequest = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const requests = [
    { id: 1, date: '07-Apr-2025', name: 'Amit Singh', mobile: '8317082165', email: 'Amitsingh@gmail.com', price: '1000', receipt: 'receipt1.jpg', status: 'Verified' },
    { id: 2, date: '04-Apr-2025', name: 'Pratibha', mobile: '9354509975', email: 'pratibhakaushik55@gmail.com', price: '1000', receipt: 'receipt2.jpg', status: 'Verified' },
    { id: 3, date: '04-Apr-2025', name: 'Pratibha', mobile: '9354509975', email: 'pratibhakaushik55@gmail.com', price: '1000', receipt: 'receipt3.jpg', status: 'Pending' },
    { id: 4, date: '03-Apr-2025', name: 'Shaily', mobile: '9719912118', email: 'Shailydhaka27@gmail.com', price: '1000', receipt: 'receipt4.jpg', status: 'Verified' },
    { id: 5, date: '01-Apr-2025', name: 'Rashmi', mobile: '9696305922', email: 'pal.rashmi2110@gmail.com', price: '1000', receipt: 'receipt5.jpg', status: 'Verified' }
  ];

  return (
    <div className="p-6 bg-gradient-to-br from-white to-blue-50 min-h-screen">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Special Batch Requests</h1>
        <Link
          to="/admin-panel/add-batch"
          className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all duration-300 shadow-sm"
        >
          Add New Batch
        </Link>
      </div>

      {/* Filters */}
      <div className="bg-white p-6 rounded-xl shadow border border-gray-200 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <input
            type="text"
            placeholder="Search batches..."
            className="px-4 py-3 bg-blue-50 text-gray-700 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-400"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select className="px-4 py-3 bg-blue-50 text-gray-700 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-400">
            <option value="">All Courses</option>
            <option value="typing">Typing</option>
            <option value="shorthand">Shorthand</option>
            <option value="theory">Theory</option>
          </select>
          <select className="px-4 py-3 bg-blue-50 text-gray-700 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-400">
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="verified">Verified</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-700">
          <thead className="bg-blue-100 text-blue-900 uppercase text-sm">
            <tr>
              <th className="px-6 py-4">Name</th>
              <th className="px-6 py-4">Mobile</th>
              <th className="px-6 py-4">Email</th>
              <th className="px-6 py-4">Price</th>
              <th className="px-6 py-4">Date</th>
              <th className="px-6 py-4">Receipt</th>
              <th className="px-6 py-4">Status</th>
              <th className="px-6 py-4">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {requests.map((req) => (
              <tr key={req.id} className="hover:bg-blue-50 transition-colors">
                <td className="px-6 py-4 font-medium">{req.name}</td>
                <td className="px-6 py-4">{req.mobile}</td>
                <td className="px-6 py-4">{req.email}</td>
                <td className="px-6 py-4">₹{req.price}</td>
                <td className="px-6 py-4">{req.date}</td>
                <td className="px-6 py-4">
                  <img
                    src={req.receipt}
                    alt="receipt"
                    className="w-10 h-10 rounded-md object-cover border border-gray-300"
                  />
                </td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    req.status === 'Pending' ? 'bg-yellow-100 text-yellow-700' :
                    req.status === 'Verified' ? 'bg-green-100 text-green-700' :
                    'bg-red-100 text-red-700'
                  }`}>
                    {req.status}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex space-x-2">
                    <button className="text-blue-600 hover:underline">Edit</button>
                    <button className="text-blue-600 hover:underline">View</button>
                    <button className="text-red-500 hover:underline">Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="mt-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-gray-600">
          Showing 1 to {entriesPerPage} of {requests.length} entries
        </div>
        <div className="flex space-x-2">
          <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">Previous</button>
          <button className="px-4 py-2 bg-white text-blue-600 border border-blue-500 rounded-lg hover:bg-blue-100 transition">1</button>
          <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">Next</button>
        </div>
      </div>
    </div>
  );
};

export default SpecialBatchRequest;
